import React from "react";
import { parseISO, format } from "date-fns";

interface DateDisplayProps {
  utcDateString: string | null;
  formatPattern?: string;
}

const LocalTimeDisplay: React.FC<DateDisplayProps> = ({
  utcDateString,
  formatPattern = "PPpp", // Default format: Mar 15, 2021, 3:25:50 PM
}) => {
  if (!utcDateString) return <span>-</span>;

  const convertToLocalTime = (dateString: string): string => {
    try {
      // Parse the UTC date string
      const date = parseISO(dateString);

      // Format the date in local timezone (browser's timezone)
      return format(date, formatPattern);
    } catch (error) {
      console.error("Error converting date:", error);
      return "Invalid date";
    }
  };

  return (
    <span>
      {convertToLocalTime(
        utcDateString.endsWith("Z") ? utcDateString : `${utcDateString}Z`
      )}
    </span>
  );
};

export default LocalTimeDisplay;
